import Resources from "../../shared/actions/resourcesActions";

export default class BaseCartAssignmentResource extends Resources {
  constructor(dispatch, url) {
    super(dispatch, "cart_assignment", url);

    this.refreshPageContentAfterCommit = true;
  }
}
